import { Component, OnDestroy, OnInit } from '@angular/core';
import { NoteRequest } from 'src/app/interfaces/userchatcrm';
import { Chats } from 'src/app/interfaces/chatData';
import { MessagesService } from 'src/app/service/messages.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-right-side-bar-comp',
  templateUrl: './right-side-bar-comp.component.html',
  styleUrls: ['./right-side-bar-comp.component.scss']
})
export class RightSideBarCompComponent implements OnInit, OnDestroy {

  notes: NoteRequest[] = [];
  selectedChat: string | undefined;
  datos: string = '';
  nameSelectedChat: any;
  private suscripciones: Subscription = new Subscription()
  constructor(private messageService: MessagesService,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) { 
    // Establecer idiomas disponibles y el idioma por defecto
    translate.addLangs(['en', 'es']);
    translate.setDefaultLang('es');
  }
  ngOnDestroy(): void {
    this.suscripciones.unsubscribe()
  }

  ngOnInit(): void {
    this.messageService.notes$.subscribe((notes) => {
      this.notes = notes;
    });
    this.messageService.obtenerInfoContacto().subscribe(
      (data) => {
        this.datos = data;
      }
    )
    this.suscripciones.add(
      this.messageService.selectedChat$.subscribe((chat) => {
        this.selectedChat = chat?.chatId;
        this.nameSelectedChat = chat?.name;
        if (!this.datos && this.selectedChat !== null) {
          // Llama a getNotesForChat cuando se selecciona un chat para obtener las notas.
          this.messageService.getNotesForChat(this.selectedChat).then((notes) => {
            this.notes = notes.data;
          });
        }else{
  
          this.messageService.getNotesForChat(this.datos).then((notes) => {
            this.notes = notes.data;
          });
        }
      })
    )
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
   
  }
    

}
